import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AccountSettingsComponent } from './account-settings.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AccountDetailsModule } from './account-details/account-details.module';
import { AccountPasswordChangeModule } from './account-password-change/account-password-change.module';
import { CompletedModule } from './completed/completed.module';
import { AccountNameChangeModule } from './account-name-change/account-name-change.module';
import { AccountPhoneChangeModule } from './account-phone-change/account-phone-change.module';
import { OtpVerificationModule } from './otp-verification/otp-verification.module';
import { AccountProfileChangeModule } from './account-profile-change/account-profile-change.module';
import { DeleteAccountConfirmModule } from './delete-account-confirm/delete-account-confirm.module';
import { DeleteAccountVerifyModule } from './delete-account-verify/delete-account-verify.module';
import { DeleteAccountSuccessModule } from './delete-account-success/delete-account-success.module';
import { DeleteAccountUnableModule } from './delete-account-unable/delete-account-unable.module';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { LocalizationService } from 'src/app/shared/services/localization.service';
import { HttpClient } from '@angular/common/http';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, '../assets/i18n/', '.json');
}
@NgModule({
  declarations: [AccountSettingsComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    AccountDetailsModule,
    AccountPasswordChangeModule,
    CompletedModule,
    AccountNameChangeModule,
    AccountPhoneChangeModule,
    AccountProfileChangeModule,
    OtpVerificationModule,
    DeleteAccountConfirmModule,
    DeleteAccountVerifyModule,
    DeleteAccountSuccessModule,
    DeleteAccountUnableModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
  ],
  providers: [LocalizationService, TranslateModule],
  exports: [AccountSettingsComponent],
})
export class AccountSettingsModule {}
